import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 路由导入
import Home from './router/home'
import League from './router/league'
import Verify from './router/verify'
//路由集合
const routes = [].concat(Home,League,Verify)
export default new Router({
  routes: routes
})
